import { cn } from '@ifixit/ui/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { type ComponentProps } from 'react';

interface BadgeProps extends ComponentProps<'span'> {
   asChild?: boolean;
}

function Badge({ className, asChild = false, ...props }: BadgeProps) {
   const Comp = asChild ? Slot : 'span';

   return <Comp data-slot="badge" className={cn(className)} {...props} />;
}

export { Badge };
